import { createSlice } from "@reduxjs/toolkit";

export const authSlice = createSlice({
  name: "auth",
  initialState: {
    token: "",
    establishment: {},
    isLogged: false,
    user: "",
    currentEstablishment: "",
  },
  reducers: {
    getToken: (state, action) => {
      return {
        ...state,
        token: action.payload,
      };
    },
    getEstablishment: (state, action) => {
      return {
        ...state,
        establishment: action.payload,
      };
    },
    reinitToken: (state) => {
      state.token = "";
    },
    setLogged: (state) => {
      state.isLogged = true;
    },
    setUser: (state, action) => {
      return {
        ...state,
        user: action.payload,
      };
    },
    setCurrentEstablishment: (state, action) => {
      return {
        ...state,
        currentEstablishment: action.payload,
      };
    },
  },
});

export const {
  getToken,
  getEstablishment,
  reinitToken,
  setLogged,
  setUser,
  setCurrentEstablishment,
} = authSlice.actions;

export default authSlice.reducer;
